import { render } from "./HeroiconsOutlineArrowCircleLeft.vue?vue&type=template&id=7c224ebc"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowCircleLeft.vue"]])

export default __exports__